import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { getPracticeAvailableProviders, setPracticeProviderAvailability } from './api';

import './styles.scss';

const GroupItem = ({ providerId, name_first, name_last, available_ind = false, toggleAvailability }) => (
	<li key={providerId} className={cn('list-group-item', { 'bg-danger-light': !available_ind, 'bg-success-light': available_ind })}>
		<div className="row row-table">
			<div className="col-xs-6">{name_first} {name_last}</div>
			<div className="col-xs-6 text-right">
				<label className="switch">
					<input type="checkbox" checked={available_ind === 1} onChange={toggleAvailability} />
					<span></span>
				</label>
			</div>
		</div>
	</li>
);

GroupItem.propTypes = {
	providerId: PropTypes.number,
	name_first: PropTypes.string,
	name_last: PropTypes.string,
	available_ind: PropTypes.number,
	toggleAvailability: PropTypes.func.isRequired
};

export default class ProviderStatus extends React.Component {
	static propTypes = {
		showNotification: PropTypes.func,
		user: PropTypes.object.isRequired
	}

	state = {
		isLoading: false,
		providers: []
	}

	handleToggleAvailability = ({ providerId, available_ind }) => {
		const { provider_practice_id } = this.props.user;
		setPracticeProviderAvailability(provider_practice_id, providerId, !available_ind)
			.then(({ data: { status: { availableInd } } }) => {
				this.setState(({ providers }) => {
					providers.forEach(provider => {
						if (provider.providerId === providerId) {
							provider.available_ind = availableInd;
						}
					});
					return { providers };
				});
			})
			.catch(() => {
				this.props.showNotification({
					status: 'danger',
					message: 'Unable to toggle Provider Availability'
				});
			});
	}

	componentDidMount() {
		this.setState({ isLoading: true });
		getPracticeAvailableProviders(this.props.user.provider_practice_id)
			.then(({ data: { status: { providers } } }) => this.setState({ providers, isLoading: false }))
			.catch(() => {
				this.setState({ isLoading: false });
				this.props.showNotification({
					status: 'danger',
					message: 'Unable to load Practice Providers'
				});
			});
	}

	render() {
		const { isLoading, providers } = this.state;
		const availableProviders = providers.filter(({ available_ind }) => !!available_ind);
		const unavailableProviders = providers.filter(({ available_ind }) => !available_ind);
		return (
			<div className="row provider-status">
				{isLoading ? (
					<span>Loading...</span>
				) : (
					<div className="col-md-4 col-md-offset-4">
						<h4>Available Providers ({availableProviders.length}/{providers.length})</h4>
						{availableProviders.length == 0 && (
							<div>No available providers!</div>
						)}
						<ul className="list-group">
							{availableProviders.map(provider => (
								<GroupItem
									key={provider.providerId}
									{...provider}
									toggleAvailability={() => this.handleToggleAvailability(provider)}
								/>
							))}
						</ul>
						<h4>Unavailable Providers ({unavailableProviders.length}/{providers.length})</h4>
						<ul className="list-group">
							{unavailableProviders.map(provider => (
								<GroupItem
									key={provider.providerId}
									{...provider}
									toggleAvailability={() => this.handleToggleAvailability(provider)}
								/>
							))}
						</ul>
					</div>
				)}
			</div>
		);
	}
}
